export enum ProgramStateTestID {
    Container = 'ProgramStateTestID.Container',
    ContentContainer = 'ProgramStateTestID.ContentContainer',
    FirstBackground = 'ProgramStateTestID.FirstBackground',
    SecondBackground = 'ProgramStateTestID.SecondBackground',
    ExitButton = 'ProgramStateTestID.ExitButton',
}
